@if (order?.id) {
  <div>
    <div class="order mt-65">
      <app-order-base-attrs [order]="order"></app-order-base-attrs>
      <div>
        <app-order-dynamic-attrs [order]="order" class="d-block"></app-order-dynamic-attrs>
      </div>
    </div>
  </div>
}
